// extracted by mini-css-extract-plugin
export default {"tableTitle":"OrderAnalytics_tableTitle__w-W94","select":"OrderAnalytics_select__PWhsz","wrapper":"OrderAnalytics_wrapper__qZH85"};